module.exports = __webpack_public_path__ + "img/close-nav-bar.05b430f5.svg";